export enum BaseLanguageSwitchColors {
  white = 'white',
  darkBlue = 'dark-blue',
}
